var styles = {
raw: ".hcr-page-container-2-2-3{min-width:320px;min-width:var(--hcr-page-min-width);max-width:1200px;max-width:var(--hcr-page-max-width);margin:0 auto;padding:0 12px;padding:0 var(--hcr-spacing-xs)}",
map:{"hcr-page-container":"hcr-page-container-2-2-3"}};

export default styles;
